<template>
  <div class="ph-shell">
    <div class="ph-main">
      <div class="ph-left">
        <div class="ph-photo-wrap">
          <img class="ph-photo" :src="personalDetails.profile_picture != null
            ? personalDetails.profile_picture
            : 'https://static.vecteezy.com/system/resources/thumbnails/020/765/399/small/default-profile-account-unknown-icon-black-silhouette-free-vector.jpg'
            " alt="User Image" />
          <div class="ph-photo-overlay">
            <div class="ph-name">
              {{ personalDetails.first_name || "" }}
              {{ personalDetails.last_name || "" }}
            </div>
            <div class="ph-role">{{ positionalInformation.designation_name || "N/A" }}</div>
          </div>
        </div>
      </div>

      <div class="ph-right">
        <div class="ph-grid">
          <div class="ph-item"><span>Employee ID:</span><strong>{{ positionalInformation.hcm_id || "N/A" }}</strong>
          </div>
          <div class="ph-item"><span>Birthday:</span><strong>{{ personalDetails.dob || "N/A" }}</strong></div>

          <div class="ph-item"><span>Duty Type:</span><strong>{{ positionalInformation.employee_duty_type_name || "N/A"
          }}</strong></div>
          <div class="ph-item"><span>Section:</span><strong>{{ positionalInformation.section_name || "N/A" }}</strong>
          </div>

          <div class="ph-item"><span>Employment Level:</span><strong>{{ employmentLevel.level || "N/A" }}</strong></div>
          <div class="ph-item"><span>Date Of Joining:</span><strong>{{ positionalInformation.joining_date || "N/A"
          }}</strong></div>
          
          <div class="ph-item"><span>Employee Grade:</span><strong>{{ employmentGrade.grade || "N/A" }}</strong></div>
          

          <div class="ph-item"><span>Status:</span><strong>{{ positionalInformation.status_name || "N/A" }}</strong>
          </div>
 <div class="ph-item"><span>Pseudo:</span><strong>{{ positionalInformation.pseudo_name || "N/A" }}</strong>
          </div>
         <div class="ph-item"><span>Date Of Separation:</span><strong>{{ positionalInformation.date_of_separation || "N/A"
          }}</strong></div>
          
          <div class="ph-item"><span>Business Email:</span><strong>{{ positionalInformation.business_email || "N/A"
          }}</strong></div>
          <div class="ph-item"><span>Reporting Authority:</span><strong>{{
            positionalInformation.reporting_authority_name || "N/A" }}</strong></div>

          
          <!-- <div class="ph-item"></div> -->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      personalDetails: {},
      positionalInformation: {},
      employmentLevel: {},
      employmentGrade: {},
    };
  },
  props: {
    userProfile: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    userProfile: {
      handler() {
        this.personalDetails =
          this.userProfile && this.userProfile.employee_personal_information
            ? this.userProfile.employee_personal_information
            : {};
        this.positionalInformation =
          this.userProfile && this.userProfile.employee_positional_information
            ? this.userProfile.employee_positional_information
            : {};
        this.employmentLevel =
          this.userProfile && this.userProfile.employment_level
            ? this.userProfile.employment_level
            : {};
        this.employmentGrade =
          this.userProfile && this.userProfile.employment_grade
            ? this.userProfile.employment_grade
            : {};
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.ph-shell {
  position: relative;
  border-radius: 12px;
  background: transparent;
  padding: 0;
}

.ph-close {
  position: absolute;
  top: -18px;
  right: -8px;
  border: 0;
  background: transparent;
  color: #f30f0f;
  font-size: 28px;
  line-height: 1;
  padding: 0;
}

.ph-main {
  display: flex;
  gap: 0;
  align-items: flex-start;
  background: #e9d7c8;
  border-radius: 10px;
  padding: 0 0 24px 0;
  box-shadow: inset 0 -4px 0 rgb(0 0 0 / 30%);
  position: relative;
  width: 100%;
}



.ph-left {
  width: 215px;
  height: fit-content;
  position: absolute;
  background: #fff;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 10px 10px;
  border-bottom-right-radius: 18px;
  overflow: hidden;
  z-index: 2;
}


.ph-photo-wrap {
  border-radius: 18px;
  border: 0;
  background: #fff;
  padding: 6px;
  width: 100%;
  position: relative;
  overflow: hidden;
}

/* Outer frame: vertical gradient — orange at the top, blended greens through
   the middle, blue at the bottom (matches the reference card). */
.ph-photo-wrap::before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 2px;
  border-radius: 18px;
  background: linear-gradient(
    180deg,
    #ff6634 0%,
    #00a041 53.37%,
    #01ccff 100%
  );
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.ph-photo {
  width: 100%;
  border-radius: 14px;
  object-fit: cover;
  display: block;
  min-height: 200px;
  height: 100%;
}

/* Inner border framing the photo itself, sitting just inside its rounded
   edge. Painted above the image but below the name/role overlay, so the
   frame tucks behind the name plate like the reference card. */
.ph-photo-wrap::after {
  content: "";
  position: absolute;
  inset: 9px;
  border: 2px solid rgb(255 255 255 / 60%);
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgb(0 0 0 / 8%);
  pointer-events: none;
}

.ph-photo-overlay {
  position: absolute;
  left: 6px;
  right: 6px;
  bottom: 6px;
  margin-top: 0;
  padding: 46px 10px 12px;
  color: #fff;
  text-shadow: 0 1px 2px rgb(0 0 0 / 55%);
  background:
    linear-gradient(to top, color-mix(in srgb, var(--primary-color) 52%, #0000), #0000 62%),
    linear-gradient(to top, rgb(0 0 0 / 26%), rgb(0 0 0 / 0%) 74%);
  border-radius: 0 0 14px 14px;
}

.ph-name {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.15;
  text-align: center;
}

.ph-role {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.ph-status {
  margin-top: 8px;
  height: 40px;
  padding: 0 10px 0 14px;
  border-radius: 999px;
  border: 1px solid #26a85a;
  background: #dcf6e3;
  color: #0b9441;
  font-size: 30px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1;
  white-space: nowrap;
}

.ph-status-toggle {
  width: 42px;
  height: 22px;
  border-radius: 999px;
  background: #19b34e;
  position: relative;
  box-shadow: inset 0 2px 3px rgb(0 0 0 / 25%);
}

.ph-status-toggle i {
  position: absolute;
  right: 2px;
  top: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
}

.ph-right {
  flex: 1;
  background: #e9d7c8;
  border-radius: 10px;
  padding: 0 25px;
  margin-left: 8px;
  width: 100%;
  max-width: 80%;
  margin-left: auto;
  position: relative;
  margin-top: 38px;
}

.ph-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 58px;
}

.ph-item {
  min-height: 34px;
  border-bottom: 1px dashed rgb(255 255 255 / 22%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #373738;
}

.ph-item span {
  font-size: 13px;
  font-weight: 400;
}

.ph-item strong {
  font-size: 13px;
  font-weight: 500;
  text-align: right;
  white-space: nowrap;
}

.ph-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.ph-view-btn {
  border: 1px solid #f3c2ae;
  background: #fff4ef;
  color: #ff6634;
  border-radius: 9px;
  height: 30px;
  padding: 0 13px;
  font-size: 22px;
  font-weight: 500;
}

.ph-view-btn i {
  font-size: 14px;
}

@media (max-width: 1199.98px) {
  .ph-main {
    flex-direction: column;
  }

  .ph-left {
    width: 100%;
    max-width: 240px;
  }

  .ph-right {
    width: 100%;
    margin-top: 8px;
  }

  .ph-grid {
    grid-template-columns: 1fr;
  }
}
</style>
